import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Header, Footer, CTA } from "./App";

export default function AboutPage() {
  const [openIndex, setOpenIndex] = useState(0);

  const features = [
    {
      title: "Proven Industry Expertise",
      //subtitle: "Hands-on experience from SAP-connected projects.",
      content:
        "Our team brings hands-on experience from SAP-connected projects, data-focused carve-outs, and workflow automation. We know how to move things forward — without disrupting what already works.",
    },
    {
      title: "Integration That Scales",
      //subtitle: "Modular approach and pragmatic interfaces.",
      content:
        "We connect systems without locking you in. From SAP to custom tools – built for growth, not complexity.",
    },
    {
      title: "Built on Real-World Experience",
      //subtitle: "",
      content:
        "We don’t theorize – we’ve done this before. Our methods are shaped by what works in actual operations.",
    },
    {
      title: "Where Process Meets Precision",
     // subtitle: "",
      content:
        "Automation only works when the logic fits. We map your flow, reduce friction, and keep things auditable.",
    },
    {
      title: "Designed Around Your Reality",
      //subtitle: "",
      content:
        "No idealized blueprints – just solutions that fit your structure. We adapt to your tools, teams, and business rhythm.",
    },
    {
      title: "Smart Execution, Not Guesswork",
      //subtitle: "",
      content:
        "We don’t just advise – we deliver, test, and refine. Each step has a reason, and every decision is traceable.",
    },
  ];

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? -1 : i);
  };

  return (
    <div className="min-h-screen bg-gray-50 text-gray-800">
      <Header />

      {/* Hero */}
      <section
      id="AboutHero"
        className="relative pt-28 pb-20 bg-center bg-cover text-white"
        style={{
          backgroundImage:
            "linear-gradient(180deg, rgba(10,20,40,0.75), rgba(10,20,40,0.65)), url('/images/about-hero.jpg')",
        }}
      >
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-2">About Us</h1>
          <p className="text-lg md:text-xl max-w-2xl mx-auto text-sky-100">
Fast, agile, and always there when you need us — that’s JUMIBI Consulting
          </p>
        </div>
      </section>

      {/* Who / Mission / What */}
      <section className="py-16">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-8 -mt-16">
            <article className="bg-white p-6 rounded-xl shadow">
              <div className="h-1 w-12 bg-sky-500 mb-4 rounded"></div>
              <h3 className="text-xl font-semibold mb-2">Who Are We</h3>
              <p className="text-gray-600 text-sm">
             At JUMIBI Consulting, we help businesses automate and innovate.
From DocInsight — our powerful platform for invoicing workflows — to ERP integration, Fiori development, and system administration support, we deliver customized solutions that transform complexity into simplicity and efficiency.
              </p>
            </article>

            <article className="bg-white p-6 rounded-xl shadow">
              <div className="h-1 w-12 bg-sky-500 mb-4 rounded"></div>
              <h3 className="text-xl font-semibold mb-2">Our Mission</h3>
              <p className="text-gray-600 text-sm">
         Fast. Agile. Personal.
At JUMIBI Consulting, we cut through complexity. No endless ticket queues — just real people, real expertise, and quick, effective solutions. We are committed to being more than a service provider — we are your trusted partner, dedicated to your success.
              </p>
            </article>

            <article className="bg-white p-6 rounded-xl shadow">
              <div className="h-1 w-12 bg-sky-500 mb-4 rounded"></div>
              <h3 className="text-xl font-semibold mb-2">What We Do</h3>
              <ul className="text-gray-600 text-sm space-y-2 list-disc list-inside">
                <li>DocInsight</li>
                <li>ERP Integration Projects</li>
                <li>ABAP & Fiori Development</li>
                <li>System Administration Support</li>
                <li>Process Automation</li>
              </ul>
            </article>
          </div>
        </div>
      </section>

      {/* 6-D Process */}
      <section id="AboutProcess" className="py-12 bg-gradient-to-b from-transparent to-white">
        <div className="max-w-6xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold mb-10">Our 6‑D Process</h2>

          <div className="grid md:grid-cols-3 gap-8 text-left">
            <div className="space-y-6">
              <div>
                <div className="text-6xl font-extrabold text-gray-100">01.</div>
                <h4 className="font-semibold text-lg">Discover</h4>
                <h4 className="font-semibold text-lg">Understanding your environment</h4>
                <p className="text-gray-600 text-sm">We analyze your current invoice workflows, approval processes, and system landscape to identify friction points and automation potential.</p>
              </div>

              <div>
                <div className="text-6xl font-extrabold text-gray-100">04.</div>
                <h4 className="font-semibold text-lg">Develop</h4>
                <h4 className="font-semibold text-lg">Configure and integrate</h4>
                <p className="text-gray-600 text-sm">We implement the solution, connect interfaces (e.g. SAP, DMS, mailbox), and tailor the frontend to match your team structures and processes.</p>
              </div>
            </div>

            <div className="space-y-6">
              <div>
                <div className="text-6xl font-extrabold text-gray-100">02.</div>
                <h4 className="font-semibold text-lg">Define</h4>
                <h4 className="font-semibold text-lg">Clarify requirements</h4>
                <p className="text-gray-600 text-sm">We define the core use case – whether it’s SAP integration, multi-level approvals, or AI-based document recognition – and scope the project accordingly.</p>
              </div>

              <div>
                <div className="text-6xl font-extrabold text-gray-100">05.</div>
                <h4 className="font-semibold text-lg">Deploy</h4>
                <h4 className="font-semibold text-lg">Launch and test</h4>
                <p className="text-gray-600 text-sm">The solution is rolled out in a controlled test phase. Selected pilot users validate performance, accuracy, and usability.</p>
              </div>
            </div>

            <div className="space-y-6">
              <div>
                <div className="text-6xl font-extrabold text-gray-100">03.</div>
                <h4 className="font-semibold text-lg">Design</h4>
                <h4 className="font-semibold text-lg">Build the solution concept</h4>
                <p className="text-gray-600 text-sm">Based on your needs, we create a modular setup including role-based access, approval logic, and a smart data extraction model.</p>
              </div>

              <div>
                <div className="text-6xl font-extrabold text-gray-100">06.</div>
                <h4 className="font-semibold text-lg">Deliver</h4>
                <h4 className="font-semibold text-lg">Go-live and grow</h4>
                <p className="text-gray-600 text-sm">After successful validation, we enable the full rollout. Our support continues – including future enhancements, locations, or scaling opportunities.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us (two-column) */}
      <section id="AboutWhyChooseUs" className="py-16">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <img
              src="/images/about-team.jpg"
              alt="Team"
              className="w-full rounded-xl shadow-lg object-cover"
            />
          </div>

          <div>
            <h3 className="text-2xl font-bold mb-4">Why Choose Us?</h3>
            <p className="text-gray-600 mb-6">
At JUMIBI Consulting, we combine deep industry expertise with innovative technology to deliver tailored solutions for your business needs. Our flagship platform, DocInsight, streamlines Invoicing, E-Invoicing, and Approval Workflows, helping you achieve greater efficiency and compliance.
            </p>

            {/* Accordion */}
            <div className="bg-white p-4 rounded-lg border shadow-sm">
              {features.map((f, i) => {
                const isOpen = openIndex === i;
                return (
                  <div key={i} className="border-b last:border-b-0">
                    <button
                      onClick={() => toggle(i)}
                      aria-expanded={isOpen}
                      className="w-full flex items-start justify-between py-4 text-left focus:outline-none"
                    >
                      <div>
                        <div className="font-semibold text-gray-800">{f.title}</div>
                        {f.subtitle && <div className="text-xs text-gray-500 mt-1">{f.subtitle}</div>}
                      </div>

                      <div className="ml-4 flex-shrink-0">
                        <span
                          className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-gray-100 text-gray-700 shadow-sm"
                          aria-hidden="true"
                        >
                          {isOpen ? "−" : "+"}
                        </span>
                      </div>
                    </button>

                    <div
                      className={`px-0 pb-4 text-sm text-gray-600 transition-all duration-200 ${isOpen ? "block" : "hidden"}`}
                    >
                      {f.content}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      {/* Numbers */}
      <section id="AboutNumbers" className="py-12 bg-white">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-sm text-gray-500">Satisfied Clients</div>
              <div className="text-2xl font-bold text-sky-700">32</div>
            </div>
            <div>
              <div className="text-sm text-gray-500">Projects Completed</div>
              <div className="text-2xl font-bold text-sky-700">78</div>
            </div>
            <div>
              <div className="text-sm text-gray-500">Processed Documents</div>
              <div className="text-2xl font-bold text-sky-700">56 M+</div>
            </div>
          </div>
        </div>
      </section>


      <CTA />
      <Footer />
    </div>
  );
}